import React, { Component } from "react";
import { connect } from "dva";
import moment from "moment";
import { Divider, Spin, Form } from "antd";
// eslint-disable-next-line import/no-extraneous-dependencies
import { router } from "umi";
import { GetQueryString } from "../../../../utils/common";
import Container from "../../../../components/Container";
import startIcon from "../assets/start.png";
import endIcon from "../assets/end.png";
import styles from "./index.less";

@Form.create()
@connect(({ securityPatrolDetail }) => {
  return {
    ...securityPatrolDetail
  };
})
class index extends Component {
  constructor(props) {
    super(props);
    this.inspectionId = GetQueryString("inspectionId");
  }

  componentDidMount() {
    this.convertor = new window.BMap.Convertor();
    this.bdMap = new window.BMap.Map("inspectionDetailMap");
    this.getDetail();
  }

  // 获取巡检详情
  getDetail = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "securityPatrolDetail/fetchPatrolDetail",
      id: this.inspectionId,
      callback: this.handleFetchTrackList
    });
  };

  // 获取轨迹列表
  handleFetchTrackList = () => {
    const { dispatch, detail } = this.props;
    const { inspectionDate } = detail;
    dispatch({
      type: "securityPatrolDetail/fetchTrajectoryList",
      params: {
        inspectionId: this.inspectionId,
        inspectionDate
      },
      callback: this.handleInitTrackList
    });
  };

  // 获取详情后对详情进行处理
  handleInitTrackList = () => {
    const { trackList } = this.props;
    let startPoint = {};
    let endPoint = {};
    if (trackList && trackList.length) {
      startPoint = JSON.parse(trackList[0]);
      endPoint = JSON.parse(trackList[trackList.length - 1]);
    }
    this.handleSetPoints(startPoint, startIcon);
    this.handleSetPoints(endPoint, endIcon);
    this.handleUpdateTrack();
  };

  // 设置起点和终点marker
  handleSetPoints = (points, icon) => {
    const { lng, lat } = points;
    if (lng || lat) {
      const bdPoint = new window.BMap.Point(lng, lat);
      const bdIcon = new window.BMap.Icon(
        icon,
        { width: 32, height: 39 },
        {
          imageSize: {
            width: 32,
            height: 39
          },
          anchor: new window.BMap.Size(17, 36)
        }
      );
      const marker = new window.BMap.Marker(points, {
        icon: bdIcon
      });
      this.bdMap.centerAndZoom(bdPoint, 20);
      this.bdMap.addOverlay(marker);
    }
  };

  // 添加折线
  handleUpdateTrack = () => {
    const { trackList } = this.props;
    const tempData = [];
    if (trackList && trackList.length) {
      trackList.forEach(item => {
        const { lng, lat } = JSON.parse(item);
        tempData.push(new window.BMap.Point(lng, lat));
      });
    }
    const polyline = new window.BMap.Polyline(tempData, {
      strokeColor: "#1AAD19",
      strokeWeight: 3,
      strokeOpacity: 1
    });
    this.bdMap.addOverlay(polyline);
  };

  // 跳转工作流
  handleJumpWorkFlow = (programCode, dangerFlag) => {
    if (dangerFlag) {
      router.push(
        `/campusSafety/securityPatrol/list/detail/workFlowList?flowCode=${programCode}&pageSource=securityPatrol&inspectionId=${this.inspectionId}&status=3`
      );
    }
  };

  render() {
    const { detail, spinProps } = this.props;
    const {
      dangerFlag,
      distance,
      durationDesc,
      endTime,
      programCode,
      startTime,
      userName,
      inspectionDate
    } = detail;
    const containerProps = {
      breStates: true,
      version: 2,
      defaultPadding: true,
      isSplitBar: true
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <Spin {...spinProps}>
            <div className="first_part">
              <div className="title">
                <div className="left">
                  <span className="verticalBar" />
                  <span>
                    {moment(inspectionDate).format("MMDD") || "-"}日巡查内容
                  </span>
                </div>
              </div>
            </div>
            <div className="second_part">
              <Divider orientation="left">详情</Divider>
              <div className="secondContent">
                <div id="inspectionDetailMap" className="mapContainer" />
                <div className="contentWrapper">
                  <div className="item">
                    <div className="title">巡查人</div>
                    <div className="result">{userName || "-"}</div>
                  </div>
                  <div className="item">
                    <div className="title">开始时间</div>
                    <div className="result">{startTime || "-"}</div>
                  </div>
                  <div className="item">
                    <div className="title">结束时间</div>
                    <div className="result">{endTime || "-"}</div>
                  </div>
                  <div className="item">
                    <div className="title">巡查时长</div>
                    <div className="result">{durationDesc || "-"}</div>
                  </div>
                  <div className="item">
                    <div className="title">巡查距离</div>
                    <div className="result">{distance || "-"}米</div>
                  </div>
                  <div className="item">
                    <div className="title">安全隐患</div>
                    {dangerFlag ? (
                      <div
                        className="result"
                        style={{ color: "#1785EC", cursor:'pointer'}}
                        onClick={() =>
                          this.handleJumpWorkFlow(programCode, dangerFlag)
                        }
                      >
                        明细
                      </div>
                    ) : (
                      <div className="result">暂无</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default index;
